import {useMutation} from "@tanstack/react-query";
import {editExpedientNoteMutationOptions} from "./edit-expedient-note.mutation-options";

export function useEditExpedientNote(id: string, noteId: number) {
  return useMutation(editExpedientNoteMutationOptions(id, noteId));
}
